const closeButtonLabel = "Zamknij";
const plPL = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  plPL as default
};
